import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import Heading from "../../../../../../common/element/Heading";
import BtnLight from "../../../../../../common/element/Buttons/btnLight";
import EmailAuditLogList from "./EmailAuditLogList";
import SearchImg from "../../../../../../assets/icons-svg/search-lg.svg";
import * as userActions from "../../../../../../actions/index";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice";
import ReactPaginate from "react-paginate";
import Table from "../../../../../../common/element/Table";
import moment from "moment";
import { debounce } from "../../../../../../common/snippet/Debouncing";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler";
import { Pagination } from "../../../../../../common/pagination";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary";
import Label from "../../../../../../common/element/Label";
import Dropdown from "../../../../../../common/element/Dropdown";
import Select from "../../../../../../common/element/Select";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import { isSameDay } from "date-fns";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${id === open ? "active" : ""} h-5 w-5 transition-transform`}
    >
      <path
        d="M14.5992 6V22.8M6.19922 14.4H22.9992"
        stroke="#5786CC"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.19922 14.4004H22.9992"
        stroke="#5786CC"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const EmailAuditLog = () => {
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  
  const [filtersort, setFiltersort] = useState("created_date");
  const [filterorder, setFilterOrder] = useState("desc");
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [searchTerm, setsearchTerm] = useState("");
  const [countData, setCountData] = useState(0);
  const [loadData, setLoadData] = useState(false);
  const [emailData, setEmailData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [iconSvg, setIconSvg] = useState(false);
  
  const [senderFilter, setSenderFilter] = useState(null);
  const [recipientFilter, setRecipientFilter] = useState(null);
  const [senderOptions, setSenderOptions] = useState([]);
  const [recipientOptions, setRecipientOptions] = useState([]);
  
  const [advanceData, setAdvanceData] = useState({
    sender: "",
    recipient: "",
    start_Date: "",
    end_Date: "",
  });

  const [date, setDate] = useState([
    { startDate: null, endDate: null, key: "custom" },
  ]);

  useEffect(() => {
    dispatch(userActions.GetEmailAuditLogsFilters()).then((response) => {
      if (response?.success === true) {
        const senders = response?.data?.senders?.map((s) => ({ value: s, label: s })) || [];
        const recipients = response?.data?.recipients?.map((r) => ({ value: r, label: r })) || [];
        setSenderOptions(senders);
        setRecipientOptions(recipients);
      }
    });
  }, [dispatch]);

  const handleDateRangeChange = (ranges) => {
    const selectedRange = ranges[date[0]?.key || "custom"];
    setDate([selectedRange]);
  };

  const staticRanges = [
    {
      label: "Today",
      range: () => {
        const startDate = new Date();
        const endDate = new Date();
        return { startDate, endDate, key: "today" };
      },
      isSelected: (range) =>
        isSameDay(range.startDate, new Date()) &&
        isSameDay(range.endDate, new Date()) &&
        range.key === "today",
    },
    {
      label: "Yesterday",
      range: () => {
        const endDate = new Date();
        endDate.setDate(endDate.getDate() - 1);
        const startDate = new Date(endDate);
        return { startDate, endDate, key: "yesterday" };
      },
      isSelected: (range) => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return (
          isSameDay(range.startDate, yesterday) &&
          isSameDay(range.endDate, yesterday) &&
          range.key === "yesterday"
        );
      },
    },
    {
      label: "Last 7 days",
      range: () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - 7);
        return { startDate, endDate, key: "last7Days" };
      },
      isSelected: (range) => {
        const endDate = new Date();
        const last7Days = new Date();
        last7Days.setDate(endDate.getDate() - 7);
        return (
          isSameDay(range.startDate, last7Days) &&
          isSameDay(range.endDate, endDate) &&
          range.key === "last7Days"
        );
      },
    },
    {
      label: "Last 30 days",
      range: () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - 30);
        return { startDate, endDate, key: "last30Days" };
      },
      isSelected: (range) => {
        const endDate = new Date();
        const last30Days = new Date();
        last30Days.setDate(endDate.getDate() - 30);
        return (
          isSameDay(range.startDate, last30Days) &&
          isSameDay(range.endDate, endDate) &&
          range.key === "last30Days"
        );
      },
    },
    {
      label: "Custom range",
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
        key: "custom",
      }),
      isSelected: (range) => range.key === "custom",
    },
  ];

  const dropdownRef = useRef(null);
  
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      iconSvg
    ) {
      setIconSvg(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [iconSvg]);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "System Email Log",
          url: "/admin/email-audit-log",
          home: "/admin/dashboard",
        },
      ])
    );
  }, [dispatch]);

  const handleSearchChange = (e) => {
    setsearchTerm(e.target.value.trim());
    setfilterpage(1);
  };
  const inputchangeSearch = useCallback(debounce(handleSearchChange), []);

  const handlePageChange = ({ selected }) => {
    setfilterpage(selected + 1);
  };

  const handleSort = (column) => {
    if (column === filtersort) {
      setFilterOrder(filterorder === "asc" ? "desc" : "asc");
    } else {
      setFiltersort(column);
      setFilterOrder("desc");
    }
  };

  const fetchEmailAuditLogs = useCallback(async () => {
    setLoadData(false);
    dispatch(
      userActions.GetallEmailAuditLogs(
        filtersort,
        filterorder,
        filterpage,
        filterlimit,
        searchTerm,
        "",
        "",
        "",
        advanceData.start_Date,
        advanceData.end_Date,
        advanceData.sender,
        advanceData.recipient
      )
    ).then((response) => {
      if (response?.success === true) {
        setEmailData(response?.data?.rows || []);
        setCountData(response?.data?.count || 0);
        setTotalPages(Math.ceil((response?.data?.count || 0) / filterlimit));
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
      }
      setLoadData(true);
    }).catch(() => {
      setLoadData(true);
    });
  }, [
    dispatch,
    filtersort,
    filterorder,
    filterpage,
    filterlimit,
    searchTerm,
    advanceData,
    handleUnauthorizedAccess,
  ]);

  useEffect(() => {
    fetchEmailAuditLogs();
  }, [fetchEmailAuditLogs]);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
    setIconSvg((prevState) => !prevState);
  };

  const handleOpenDate = (value) => {
    setOpen(open === value ? 0 : value);
  };

  const applyFilterHandler = () => {
    const formattedDateSD = date[0]?.startDate ? moment(date[0].startDate).format("YYYY-MM-DD") : "";
    const formattedDateED = date[0]?.endDate ? moment(date[0].endDate).format("YYYY-MM-DD") : "";
    
    setAdvanceData({
      sender: senderFilter?.value || "",
      recipient: recipientFilter?.value || "",
      start_Date: formattedDateSD,
      end_Date: formattedDateED,
    });
    setfilterpage(1);
    setIconSvg(false);
  };

  const clearFilter = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, 1000);
    
    setSenderFilter(null);
    setRecipientFilter(null);
    setDate([{ startDate: null, endDate: null, key: "custom" }]);
    
    setAdvanceData({
      sender: "",
      recipient: "",
      start_Date: "",
      end_Date: "",
    });
    setfilterpage(1);
    setIconSvg(false);
  };

  const Toggle = (
    <BtnLight
      onClick={() => handleOpen(2)}
      className="h-10 w-40 flex items-center justify-center gap-2 text-12"
    >
      Filters
      {iconSvg ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.82125 4.72239C2.19097 4.01796 1.87583 3.66574 1.86394 3.3664C1.85361 3.10636 1.96536 2.85643 2.16603 2.69074C2.39704 2.5 2.86966 2.5 3.81491 2.5H16.184C17.1293 2.5 17.6019 2.5 17.8329 2.69074C18.0336 2.85643 18.1453 3.10636 18.135 3.3664C18.1231 3.66574 17.808 4.01796 17.1777 4.72239L12.4225 10.037C12.2968 10.1774 12.234 10.2477 12.1892 10.3276C12.1495 10.3984 12.1203 10.4747 12.1027 10.554C12.0828 10.6435 12.0828 10.7377 12.0828 10.9261V15.382C12.0828 15.5449 12.0828 15.6264 12.0565 15.6969C12.0333 15.7591 11.9955 15.8149 11.9463 15.8596C11.8907 15.9102 11.815 15.9404 11.6637 16.001L8.83039 17.1343C8.5241 17.2568 8.37096 17.3181 8.24802 17.2925C8.14052 17.2702 8.04617 17.2063 7.98551 17.1148C7.91613 17.0101 7.91613 16.8452 7.91613 16.5153V10.9261C7.91613 10.7377 7.91613 10.6435 7.89623 10.554C7.87858 10.4747 7.84943 10.3984 7.8097 10.3276C7.76491 10.2477 7.70209 10.1774 7.57645 10.037L2.82125 4.72239Z"
            stroke="#344054"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="18"
          height="14"
          viewBox="0 0 18 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 3.66602L11.5 3.66602M11.5 3.66602C11.5 5.04673 12.6193 6.16602 14 6.16602C15.3807 6.16602 16.5 5.04673 16.5 3.66602C16.5 2.2853 15.3807 1.16602 14 1.16602C12.6193 1.16602 11.5 2.2853 11.5 3.66602ZM6.5 10.3327L16.5 10.3327M6.5 10.3327C6.5 11.7134 5.38071 12.8327 4 12.8327C2.61929 12.8327 1.5 11.7134 1.5 10.3327C1.5 8.95197 2.61929 7.83268 4 7.83268C5.38071 7.83268 6.5 8.95197 6.5 10.3327Z"
            stroke="#344054"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </BtnLight>
  );

  return (
    <React.Fragment>
      <div className="flex justify-between mb-5 flex-wrap gap-y-2.5">
        <Heading>System Email Log</Heading>
        <div className="flex gap-3 flex-wrap gap-y-2.5">
          <div className="w-80 h-10">
            <div className="input-wrapper relative">
              <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                <img src={SearchImg} alt="Search" className="h-5" />
              </div>
              <input
                type="text"
                className="input pl-11 w-full input-shadow h-10 text-sm border border-gray-300 rounded-lg appearance-none text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Search subject, recipients, body..."
                onChange={inputchangeSearch}
              />
            </div>
          </div>
          <div
            className={`filter-block ${iconSvg === true ? "active" : ""}`}
            ref={dropdownRef}
          >
            <Dropdown renderTitle={Toggle}>
              <div className="p-4 bg-white rounded-lg shadow-lg">
                <div className="mb-4">
                  <Label className="font-semibold mb-2 block text-xs text-gray-700">Sender</Label>
                  <Select
                    placeholder="Select Sender"
                    className="select-option hide-seacrh-icon"
                    options={senderOptions}
                    value={senderFilter}
                    onChange={(option) => setSenderFilter(option)}
                  />
                </div>
                <div className="mb-4">
                  <Label className="font-semibold mb-2 block text-xs text-gray-700">Recipient</Label>
                  <Select
                    placeholder="Select Recipient"
                    className="select-option hide-seacrh-icon"
                    options={recipientOptions}
                    value={recipientFilter}
                    onChange={(option) => setRecipientFilter(option)}
                  />
                </div>
                <Accordion open={open === 1} icon={<Icon id={1} open={open} />}>
                  <AccordionHeader onClick={() => handleOpenDate(1)} className="text-sm font-semibold border-b-0 py-2">
                    Date Range
                  </AccordionHeader>
                  <AccordionBody>
                    <div className="calander_wrapper overflow-x-auto max-w-full">
                      <DateRangePicker
                        ranges={date}
                        onChange={handleDateRangeChange}
                        staticRanges={staticRanges}
                        moveRangeOnFirstSelection={true}
                        retainEndDateOnFirstSelection={false}
                        startDatePlaceholder="Start date"
                        endDatePlaceholder="End date"
                        showMonthAndYearPickers={false}
                        rangeColors={["#5786CC"]}
                        weekStartsOn={1}
                      />
                    </div>
                  </AccordionBody>
                </Accordion>
                <div className="flex gap-2 border-t border-gray-200 pt-4 mt-4">
                  <BtnLight disabled={buttonDisabled} onClick={clearFilter} className="flex-1">
                    Clear Filters
                  </BtnLight>
                  <BtnPrimary disabled={buttonDisabled} onClick={applyFilterHandler} className="flex-1">
                    Apply Filters
                  </BtnPrimary>
                </div>
              </div>
            </Dropdown>
          </div>
        </div>
      </div>

      <EmailAuditLogList
        emailData={emailData}
        handleSort={handleSort}
        filtersort={filtersort}
        filterorder={filterorder}
      />

      {!loadData && (
        <div className="py-8">
          <ThreeDotBouncing />
        </div>
      )}

      {loadData && (
        <div className="flex justify-between mt-3 flex-wrap items-center gap-4">
          <Pagination
            totalCount={countData}
            pageNumber={filterpage}
            displayPage={emailData.length}
            UpdatePageLimit={setfilterlimit}
            UpdatePage={setfilterpage}
          />
          {countData > 0 && (
            <ReactPaginate
              className="flex justify-content-end p-2 align-items-center pagination-wrap gap-1"
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              previousLinkClassName={"prev-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"prev-link"}
              previousClassName={"px-4 rounded-md bg-blue-700 text-white"}
              nextClassName={"px-4 rounded-md bg-blue-700 text-white"}
              pageLinkClassName={"px-4 rounded-md"}
              activeLinkClassName={"w-9 h-9 bg-blue-700 text-white flex items-center justify-center rounded-full font-bold"}
              disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
              renderOnZeroPageCount={null}
              forcePage={filterpage - 1}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default EmailAuditLog;
